import { useParams, useLocation } from "react-router-dom";
import { useIsTrainerDashboard } from "@/hooks/useIsTrainerDashboard";

/**
 * Returns the base path for course navigation links.
 * Handles enrollment-based routes (/course/:enrollmentId), admin preview
 * routes (/preview/:courseExternalId) and the trainer-preview route
 * (/course/:enrollmentId/trainer-preview).
 */
export const useCourseBasePath = () => {
  const { enrollmentId, courseExternalId } = useParams<{
    enrollmentId?: string;
    courseExternalId?: string;
  }>();
  const { pathname } = useLocation();
  const isTrainerDashboard = useIsTrainerDashboard();

  if (courseExternalId) return `/preview/${courseExternalId}`;

  const isTrainer = pathname.includes("/trainer-preview") || isTrainerDashboard;
  if (isTrainer && enrollmentId)
    return `/course/${enrollmentId}/trainer-preview`;

  return `/course/${enrollmentId}`;
};
